import { useEffect, useRef, useState } from 'react';
import { EpdLinks } from 'routes/EpdRoutes';
import { EPDCopyGroupStatus } from 'services/EpdClient';
import { DashboardListItemModel } from 'types/dashboard/DashboardListItemModel';
import { EPDGroupCardDashboardStatus } from 'styles/v2/Styles.styled';
import { dateToIsoString } from 'util/utils';
import { CardName, CardFormatText, CardDate, CopyGroupCard } from './styles';
import Tooltip from 'components/controls/Tooltip';

type TProps = {
  epdGroup: DashboardListItemModel;
  background: any;
};

const EpdGroupCard = ({ epdGroup, background }: TProps) => {
  const titleRef = useRef<HTMLDivElement>(null);
  const [isTitleEllipsed, setIsTitleEllipsed] = useState(false);

  useEffect(() => {
    const element = titleRef.current;

    if (!element) {
      return;
    }

    setIsTitleEllipsed(element.scrollHeight > element.clientHeight);
  }, [epdGroup.name]);

  const groupStatus =
    epdGroup.groupStatus === EPDCopyGroupStatus.DeclinedCopyByLicenseeAdmin ? 'Declined publication' : epdGroup.groupStatus;

  return (
    <CopyGroupCard to={EpdLinks.editCopyEpd(epdGroup.id)} background={background}>
      <div>
        <EPDGroupCardDashboardStatus status={epdGroup.groupStatus}>{groupStatus}</EPDGroupCardDashboardStatus>
        <CardName ref={titleRef} style={{ marginTop: 16 }}>
          {epdGroup.name}
          {isTitleEllipsed && <Tooltip position="title">{epdGroup.name}</Tooltip>}
        </CardName>
      </div>
      <div>
        <CardFormatText>Copy Group</CardFormatText>
        <CardDate>Created: {dateToIsoString(epdGroup?.createdAt)}</CardDate>
      </div>
    </CopyGroupCard>
  );
};

export default EpdGroupCard;
